<template>
  <div id="ControlBar">
    <div class="play-btn" ref="playBtnRef" @click="play">
      <i
        class="iconfont"
        :class="played ? 'icon-xingzhuang' : 'icon-sanjiaoxing'"
      ></i>
    </div>

    <div class="reStartPlay-btn" ref="reStartBtnRef" @click="reStart">
      <img src="~@/assets/images/video/video-refresh.png" alt="" />
    </div>

    <div class="play-quality-btn" ref="qualityBtnRef">
      <span
        v-for="item in qualityList"
        v-show="Number(quality) !== item.value"
        :key="item.value"
        @click="changeQuality(item.value)"
        >{{ item.name }}</span
      >
    </div>

    <div class="full-screen-btn" ref="fullScreenBtnRef" @click="fullScreen">
      <img
        :src="
          require(`@/assets/images/video/${
            full ? 'video-scale-icon' : 'video-full-icon'
          }.png`)
        "
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "control-bar",
  props: {
    played: {
      type: Boolean,
      default: false,
    },
    quality: {
      type: [String, Number],
      default: 0,
    },
    qualityList: {
      type: Array,
      default: () => [
        { name: "高清", value: 0, url: "" }, //* 高清
        // { name: "标清", value: 1, url: "" }, //* 标清
        { name: "标清", value: 2, url: "" }, //* 流畅
      ],
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    fullScreen() {
      this.$emit("fullScreen");
    },
    changeQuality(quality) {
      if (this.qualityList.length === 1) {
        const { name } = this.qualityList[0];
        return this.$message.error(`当前视频仅支持${name}播放`);
      }
      this.$emit("changeQuality", { value: quality });
    },
    reStart() {
      this.$emit("reStart");
    },
    play() {
      if (this.played) {
        this.$emit("pause");
      } else {
        this.$emit("play");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./_ControlBar.css");
</style>
